module.exports = __webpack_public_path__ + "tm.c8f7210db34658ec1fbe.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/tm.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/tm.svg
// module chunks = styles